export const VIDEO_INITIATE = 'VIDEO_INITIATE';
export const VIDEO_START = 'VIDEO_START';
export const VIDEO_JOIN = 'VIDEO_JOIN';
export const VIDEO_ACCEPT = 'VIDEO_ACCEPT';
export const VIDEO_STOP = 'VIDEO_STOP';
export const VIDEO_STOPPED = 'VIDEO_STOPPED';
export const VIDEO_DECLINE = 'VIDEO_DECLINE';
export const VIDEO_DECLINED = 'VIDEO_DECLINED';
export const VIDEO_CANCEL = 'VIDEO_CANCEL';
export const VIDEO_CANCELLED = 'VIDEO_CANCELLED';
export const VIDEO_MISS = 'VIDEO_MISS';
